import { Search } from 'lucide-react'

import { DirectionArrow } from '../../assets/direction-arrow'
import { professionMap } from '../../schemas/profession'
import type { PublicUserData } from '../../schemas/user'
import { ProfilePhotoFallback } from '../profile-photos/profile-avatar'

const UserSearchCard = ({ user, onClick }: { user: PublicUserData; onClick: () => void }) => {
  return (
    <div
      className="group flex w-full cursor-pointer flex-row items-center justify-between gap-3 py-2"
      onClick={onClick}
    >
      <div className="flex flex-row items-center  gap-2">
        <Search className="size-[24px] min-h-[20px] min-w-[20px] text-muted group-hover:text-primary" />
        <div className="flex flex-row items-center gap-2">
          <div
            className="size-[40px] max-h-[40px] min-h-[40px] min-w-[40px] max-w-[40px] rounded-full border-[3px] border-white bg-white"
            style={{
              boxShadow: '0px 1px 10px 0px rgba(27,48,41,0.10)',
            }}
          >
            <img
              src={user.profilePhoto || ProfilePhotoFallback}
              alt={user.fullName}
              className="size-full rounded-full"
            />
          </div>

          <div className="flex flex-col">
            <p className="line-clamp-1 text-sm font-medium">
              <span className="font-bold">
                {user.firstName} {user.lastName}
              </span>
              <span className="text-muted"> &#xB7; @{user.username}</span>
            </p>
            <p className="text-xs text-muted">{professionMap[user.profession]?.label || ''}</p>
          </div>
        </div>
      </div>
      <DirectionArrow className="size-5 text-muted opacity-0 transition-opacity duration-300 group-hover:text-primary group-hover:opacity-100" />
    </div>
  )
}

const UserSearchCardSkeleton = () => {
  return (
    <div className="flex flex-row items-center gap-3 py-2">
      <Search className="size-[24px] min-h-[20px] min-w-[20px] text-muted" />
      <div className="flex flex-row items-center gap-2">
        <div className="size-[40px] animate-pulse rounded-full bg-gray-200" />
        <div className="flex flex-col gap-1">
          <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
          <div className="h-3 w-24 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
    </div>
  )
}

export default UserSearchCard
export { UserSearchCardSkeleton }
